
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class BasicInfoField extends Vue {
  @Prop({ required: true }) readonly label!: string
  @Prop({ required: true }) readonly text!: string
}
